import { Company } from 'src/components/modules/companies/types';

import { createApiActions } from '../../../helpers/actions';

export const getCompanies = createApiActions()(
  'company/getCompanies',
  'company/getCompaniesSuccess',
  'company/getCompaniesError',
  (page: number, searchText: string) => ({ page, searchText })
);

export const editCompany = createApiActions()(
  'company/editCompany',
  'company/editCompanySuccess',
  'company/editCompanyError',
  (companyId: number, data: Company) => ({ companyId, data })
);

export const addCompany = createApiActions()(
  'company/addCompany',
  'company/addCompanySuccess',
  'company/addCompanyError',
  (data: Company) => ({ data })
);
